'use client'

import { useEffect, useState } from 'react'
import Image from 'next/image'
import { cn } from '@/lib/utils'
import { getCachedGpTeam, isGpTeam, loadGpTeam, subscribeGpTeam, type GpTeam } from '@/lib/gp-team'

/**
 * The GP mark shown right after a GamerPlug team member's name. Renders
 * nothing for everyone else, so it can sit beside any gamertag. Pass the
 * user id when the call site has it; the gamertag alone also works.
 */
export function GpBadge({
  userId,
  gamertag,
  size = 14,
  className,
}: {
  userId?: string | null
  gamertag?: string | null
  size?: number
  className?: string
}) {
  const [team, setTeam] = useState<GpTeam | null>(getCachedGpTeam)

  useEffect(() => {
    let active = true
    const unsubscribe = subscribeGpTeam((t) => {
      if (active) setTeam(t)
    })
    loadGpTeam().then((t) => {
      if (active) setTeam(t)
    })
    return () => {
      active = false
      unsubscribe()
    }
  }, [])

  if (!team || !isGpTeam(team, userId, gamertag)) return null

  return (
    <Image
      // A 64px copy of the GP mark, served as-is: it's tiny, and skipping the
      // optimizer means the badge paints with the name instead of after it.
      src="/gp-badge.png"
      alt="GamerPlug team"
      title="GamerPlug team"
      width={size}
      height={size}
      unoptimized
      className={cn('inline-block shrink-0 align-middle', className)}
      style={{ width: size, height: size }}
    />
  )
}
